import { Handle, Position } from 'react-flow-renderer';
import s from './nodes.module.scss'

export function ScriptNode(props) {
  return (
    <>
      <Handle type="target" position={Position.Top} />
      <div className={s.scriptNodeContent} >
        <label htmlFor="text">Script: {props.data.label}</label>
      </div>
      <Handle type="source" position={Position.Bottom}/>
    </>
  );
}